export class UpdateUserStatusRequest {

  userId: string;
  updatedBy: string;
  status: Boolean;

}
